import React from 'react';
import PropTypes from 'prop-types';


import * as customerFormConstants from './customerFormConstants';


import FormBlock from '../../../global/Form/FormBlock';
import FormTextInput from '../../../global/Form/FormElement/FormTextInput';
import {AddressForm} from '../../Address';
import {BillingDataForm} from '../../Billing/BillingDataForm';
import {I18nMessage} from '../../I18n';
import {InfoBox} from '../../../global';
import {ValidatingForm} from '../../../global/Form';
import {customerConstants} from '../index';
import {inputConstants} from '../../../global/Form/Input';


function CustomerForm({customerData, isNameDisabled, onData}) {

    const buyerSellerCountryFilter = ({isBuyerReady, isSellerReady}) => {

        // only countries with particular interest
        if (customerData.interest === customerConstants.CUSTOMER_INTEREST_BUYER) {

            return isBuyerReady;
        }
        if (customerData.interest === customerConstants.CUSTOMER_INTEREST_SELLER) {

            return isSellerReady;
        }

        return true;
    };

    const buyerCountryFilter = ({isBuyerReady}) => {

        return isBuyerReady;
    };

    return (
        <ValidatingForm
            data={customerData}
            id={'customer.form'}
            onIsInvalid={data => onData(data, false)}
            onIsValid={data => onData(data, true)}
            validationSchema={customerFormConstants.SCHEMA_CUSTOMER_FORM}
        >
            {({form}) => {

                let customerAddressCountryFilter = buyerSellerCountryFilter;
                let billingAddressCountryFilter = buyerSellerCountryFilter;
                if (!form.getData('billingData.isBillingAddressMainAddress')) {
                    customerAddressCountryFilter = buyerCountryFilter;
                }

                return (
                    <>
                        <FormBlock>

                            <legend>
                                <I18nMessage id={'customer.form.legend.general'}/>
                            </legend>

                            <FormTextInput
                                autocomplete={inputConstants.AUTOCOMPLETE_ORGANIZATION}
                                error={form.getCurrentError('name')}
                                id={'customerName'}
                                isDisabled={isNameDisabled}
                                isRequired={form.isRequired('name')}
                                labelI18n={'customer.form.field.name.label'}
                                maxLength={customerFormConstants.CUSTOMER_NAME_LENGTH_MAX}
                                name={'customerName'}
                                onChange={name => form.mergeData({name})}
                                placeholderI18n={'customer.form.field.name.placeholder'}
                                value={form.getData('name')}
                            />

                        </FormBlock>

                        <AddressForm
                            address={form.getData('address')}
                            countryFilter={customerAddressCountryFilter}
                            legendI18n={'customer.form.legend.address'}
                            onChange={address => form.mergeData({address})}
                        />

                        {customerData.interest === customerConstants.CUSTOMER_INTEREST_SELLER && (
                            <InfoBox contentI18n={'customer.form.info.billingDataCountrySeller'}/>
                        )}

                        <BillingDataForm
                            billingData={form.getData('billingData')}
                            countryFilter={billingAddressCountryFilter}
                            onChange={billingData => form.mergeData({billingData})}
                        />
                    </>
                );
            }}
        </ValidatingForm>
    );
}


CustomerForm.propTypes = {
    customerData: PropTypes.shape(customerConstants.SHAPE_CUSTOMER),
    isNameDisabled: PropTypes.bool,
    onData: PropTypes.func.isRequired
};

CustomerForm.defaultProps = {
    isNameDisabled: false
};


export default CustomerForm;
